/* 布局 */
//前台
import Layout from "@views/layout";

const goodssacrificeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodssacrifice/list",
        name: "GOODSSACRIFICE",
        meta: {
            title: "网上代祭祀套餐",
            keepAlive:true
        },
        component: () => import("@views/business/goodssacrifice/index.vue"),
    },
        ],
};

export default goodssacrificeRouter;
